/** Said under a server that is always Dedicated: "Process Pro Global always uses a dedicated DB server." */
export const dedicatedOnlyStatement = (server: string): string => `Process Pro Global always uses a dedicated ${server}.`
